var exports = {
  "zr": "ScreenShareBufferingFrame.module__root___aDFGNG",
  "WO": "ScreenShareBufferingFrame.module__corner___aDFGNG",
  "u1": "ScreenShareBufferingFrame.module__spinner___aDFGNG",
  "MI": "ScreenShareBufferingFrame.module__failureContent___aDFGNG",
  "nV": "ScreenShareBufferingFrame.module__failureTitle___aDFGNG",
  "eB": "ScreenShareBufferingFrame.module__failureSubtext___aDFGNG",
  "sM": "ScreenShareBufferingFrame.module__srOnly___aDFGNG",
  "Om": "ScreenShareBufferingFrame.module__dot___aDFGNG",
  "wV": "ScreenShareBufferingFrame.module__dot0___aDFGNG",
  "TQ": "ScreenShareBufferingFrame.module__dot1___aDFGNG",
  "Mc": "ScreenShareBufferingFrame.module__dot2___aDFGNG",
  "FA": "ScreenShareBufferingFrame.module__dot3___aDFGNG",
  "yY": "ScreenShareBufferingFrame.module__dot4___aDFGNG",
  "Ff": "ScreenShareBufferingFrame.module__dot5___aDFGNG",
  "Mi": "ScreenShareBufferingFrame.module__dot6___aDFGNG",
  "FG": "ScreenShareBufferingFrame.module__dot7___aDFGNG",
  "MZ": "ScreenShareBufferingFrame.module__dot8___aDFGNG",
};

module.exports = exports;
